export const UI_5_4_tableRow = [
    [
      {
        cellName: "번호",
        id: "qnaNo",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "산업단지명",
        id: "complexInloName",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "회사명",
        id: "companyInloName",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "사업장명",
        id: "plantInloName",
        row: 1,
        col: 1,
        style: { width: "6%" },
      },
      {
        cellName: "문의분류",
        id: "qnaClCd",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "제목",
        id: "qnaTitle",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "등록일시",
        id: "regDtm",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "진행상태",
        id: "qnaStCd",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "",
        id: "answerBtn",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
    ]
  ]
  
  
  